import script from "./EventInfoPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./EventInfoPopover.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__